import React from 'react';
import { shape } from 'prop-types';

import Quote from 'components/About/Quote/Quote';
import Text from 'components/About/Text/Text';
import Video from 'components/About/Video/Video';
import Image from 'components/About/Image/Image';

const Components = {
  quoteElement: Quote,
  textElement: Text,
  videoElement: Video,
  imageElement: Image,
};

const DynamicComponent = ({ content }) => {
  // Check if component is defined above
  if (typeof Components[content.type] !== 'undefined') {
    const Component = Components[content.type];
    return <Component content={content} />;
  }

  // Fallback if the component doesn't exist
  return (
    <p>
      The component <strong>{content.type}</strong> has not been created yet.
    </p>
  );
};

DynamicComponent.propTypes = {
  content: shape().isRequired,
};

export default DynamicComponent;
